import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    margin: ({ expanded }) => `2.25rem 0 ${expanded ? 1 : -2}rem 0`,
    padding: ({ isSmall, isExtraSmall }) =>
      `0 ${isExtraSmall ? '0.5' : isSmall ? 1.75 : 3.5}rem`
  },

  title: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '1rem',
    marginLeft: ({ expandable }) => (expandable ? '1rem' : '0'),
    borderBottom: '1px solid #F1F1F1',
    paddingBottom: '0.5rem',
    fontSize: theme.size.base
  },

  button: {
    marginRight: '0.5rem',
    padding: '4px',
    cursor: 'pointer'
  },

  children: {
    position: 'relative'
  }
}))

export default useStyles
